<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const definitionLabelVariants = cva('font-heading text-secondary-foreground uppercase', {
  variants: {
    size: {
      sm: 'text-badge-sm',
      md: 'text-badge-md'
    }
  },
  defaultVariants: {
    size: 'sm'
  }
})

type DefinitionLabelProps = VariantProps<typeof definitionLabelVariants>

withDefaults(
  defineProps<{
    size?: DefinitionLabelProps['size']
  }>(),
  {
    size: 'sm'
  }
)
</script>

<template>
  <span :class="classMerge(definitionLabelVariants({ size }))">
    <slot />
  </span>
</template>
